import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dial-panel__select-option" }
const _hoisted_2 = { class: "dial-panel__select-option" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconDialpad = _resolveComponent("IconDialpad")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcSelect = _resolveComponent("NcSelect")
  const _component_IconBackspaceOutline = _resolveComponent("IconBackspaceOutline")
  const _component_NcPopover = _resolveComponent("NcPopover")

  return (_openBlock(), _createBlock(_component_NcPopover, {
    id: "dial-popover",
    ref: "popover",
    "popover-base-class": "dial-popover",
    container: $props.container,
    onShow: $options.prefillCode
  }, {
    trigger: _withCtx(() => [
      _createVNode(_component_NcButton, {
        disabled: $props.disabled,
        "aria-label": $options.t('spreed', 'Open dialpad'),
        title: $options.t('spreed', 'Open dialpad')
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconDialpad, { size: 20 })
        ]),
        _: 1
      }, 8, ["disabled", "aria-label", "title"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "panel",
        class: "dial-panel",
        tabindex: "0",
        onKeydownCapture: _cache[1] || (_cache[1] = (...args) => ($options.handleKeyDown && $options.handleKeyDown(...args)))
      }, [
        (!$props.dialing)
          ? (_openBlock(), _createBlock(_component_NcSelect, {
              key: 0,
              ref: "regionSelect",
              modelValue: $data.region,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.region) = $event)),
              class: "dial-panel__select",
              options: $setup.options,
              "append-to-body": false,
              clearable: false,
              "aria-label-combobox": $options.t('spreed', 'Select a region'),
              placeholder: $options.t('spreed', 'Select a region'),
              label: "dial_and_name",
              "onOption:selected": $options.dialCode
            }, {
              option: _withCtx(({ dial_code, name }) => [
                _createElementVNode("span", _hoisted_1, [
                  _createElementVNode("b", null, _toDisplayString(dial_code), 1),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createElementVNode("em", null, _toDisplayString(name), 1)
                ])
              ]),
              "selected-option": _withCtx(({ dial_code, name }) => [
                _createElementVNode("span", _hoisted_2, [
                  _createElementVNode("b", null, _toDisplayString(dial_code), 1),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("em", null, _toDisplayString(name), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "aria-label-combobox", "placeholder", "onOption:selected"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buttons, (button) => {
          return (_openBlock(), _createBlock(_component_NcButton, {
            key: button.value,
            class: "dial-panel__button",
            onClick: $event => ($options.handlePad(button.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(button.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        (!$props.dialing)
          ? (_openBlock(), _createBlock(_component_NcButton, {
              key: 1,
              class: "dial-panel__button",
              variant: "tertiary",
              "aria-label": $options.t('spreed', 'Delete'),
              onClick: $options.handleBackspace
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconBackspaceOutline, { size: 20 })
              ]),
              _: 1
            }, 8, ["aria-label", "onClick"]))
          : _createCommentVNode("", true)
      ], 544)
    ]),
    _: 1
  }, 8, ["container", "onShow"]))
}